/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The different types which settings can take.
 */
export enum EnumValueType {
    /**
     * A string-valued customization
     */
    PlainText = 0,
    /**
     * A file-valued. Values of this type will contain an identifier which refers to an existing file.
     */
    File = 1,
    /**
     * A numerical customization. Will be interpreted as a double-precision floating point number
     */
    Float = 2,
    /**
     * HTML formatted string value.
     */
    Html = 3,
    /**
     * Integer value.
     */
    Integer = 4,
    /**
     * Boolean value
     */
    Boolean = 5,
    /**
     * LinkField value
     */
    Link = 6,
    /**
     * Json encoded value
     */
    Json = 7,
}
